/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PaymentService } from '../services';
import toast from 'react-hot-toast';

const RequirePaidPlan = ({ children }) => {
  const user = useSelector(state => state.user);
  const [pay, setPay] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (!pay && location.pathname !== '/payments') {
      toast.error('Debe pagar el plan para seguir usando la plataforma');
    }
  }, [location.pathname, pay]);

  useEffect(() => {
    checkPayment();
  }, []);

  const checkPayment = async () => {
    const response = await PaymentService.payment.checkPayment({ user_id: user?.id });
    if (!response.plan_user || !user?.plan_days) {
      setPay(false);
    }
  }

  if (!pay) {
    if (location.pathname !== '/payments') {
      return <Navigate to="/payments" replace />;
    }
  }

  return children;
};


export default RequirePaidPlan;